import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: '90%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '2rem'
	},
	siteSync: {
		display: 'flex',
		justifyContent: 'center',
		margin: '2rem'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 'fit-content !important',
		height: 'fit-content',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem',
		overflowY: 'scroll'
	},

	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},

	inputConfigContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		margin: '2rem',
		columnGap: '1rem'
	},
	delIcon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	output: {
		overflow: 'hidden',
		overflowWrap: 'break-word',
		backgroundColor: '#D7DBDD',
		position: 'relative',
		borderRadius: '4px',
		margin: '4rem auto',
		marginTop: '1rem',
		overflowY: 'scroll !important',
		maxHeight: '80vh',
		textAlign: 'left',
		padding: '1rem',
		width: '99%',
		color: 'rgba(0, 0, 0, 0.38)'
	}
}));
